export default "__VITE_ASSET__Bn3lt_Js__ 1920w";